<template>
  <el-container>
    <el-header>
      <ul>大疆商品</ul>
    </el-header>
    <el-container>
      <el-aside width="92px">
        <div class="main-aside">
          <ul class="aside-dayorlive" @click="checkDay($event,i)" ref="dayorlive" v-for="(item,i) in asideList" :key="i"
            v-on:mouseover.stop="checkDayhandleMouseOver($event)" v-on:mouseout.stop="checkDayhandleMouseOut($event)">
            <svg-icon :icon-class="item.icon" class="svg_icon" />{{ item.label }}
          </ul>
        </div>
      </el-aside>
      <el-main>
        <div class="dad" v-if="modulecheck==0" :style="{ height: `${screenHeight-60-12-12}px` }">
          <div class="dason">
            商品更新
          </div>
          <div class="first-div">
            <el-date-picker v-model="date" :picker-options="expireTimeOPtion" type="date" placeholder="选择日期"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="mini" style="width: 140px;margin-right: 12px;">
            </el-date-picker>
            <el-select v-model="states" placeholder="请选择" size="mini" style="width: 120px;margin-right: 12px;">
              <el-option v-for="item in stateArr" :key="item.code" :label="item.label" :value="item.code">
              </el-option>
            </el-select>
            <el-select v-model="plat" placeholder="请选择" @change="myOperatorName(plat)" size="mini" style="width: 100px;margin-right: 12px;">
              <el-option v-for="item in platArr" :key="item.code" :label="item.label" :value="item.code">
              </el-option>
            </el-select>
            <el-select v-model="operator" placeholder="运营人员" size="mini" style="width: 120px;margin-right: 12px;">
              <el-option v-for="item in operatorArr" :key="item.code" :label="item.label" :value="item.code">
              </el-option>
            </el-select>
            <el-input v-model="spuId" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
            <el-button size="mini" id="newAdd" @click="search">搜索</el-button>
          </div>
          <div class="two-table">
            <el-table :height="screenHeight-60-12-12-12-32-32-55-20" style="width: 100%" :data="tableData"
              class="custom-table">
              <el-table-column label="商品名称" width="120" fixed="" align="center">
                <template slot-scope="sc">
                  <span :title="sc.row.outerSpuName">{{ beautySub(sc.row.outerSpuName,10) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="SPU" width="120" fixed="" align="center">
                <template slot-scope="sc">
                  <span :title="sc.row.bzSpuName">{{ beautySub(sc.row.bzSpuName,10) }}</span>
                  <div v-if="sc.row.isOnline==0" style="width: 40px;height: 18px;text-align: center;display: inline-block;
                    line-height: 18px;color: #fff;background: #FA9797;border-radius: 4px;">下架</div>
                  <br>
                  <el-button type="text" @click="reflash(sc.row)">刷新</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="spuId" label="商品ID" width="130" fixed="" align="center">
              </el-table-column>
              <el-table-column label="SKU" width="260" align="left" fixed="">
                <template slot-scope="sc">
                  <div class="sku-cell" v-for="(item,i) in  sc.row.skuList" :key="i" :title="item.bzSkuName">
                    {{ beautySub(item.bzSkuName,10) }}
                    <el-button type="text" @click="copyText(item)">复制链接</el-button>
                    <div v-if="item.isOnline==0" style="width: 40px;height: 18px;text-align: center;display: inline-block;
                    line-height: 18px;color: #fff;background: #FA9797;border-radius: 4px;">下架</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="SKU名称/ID" width="260" align="left">
                <template slot-scope="sc">
                  <div class="sku-cell" v-for="(item,i) in  sc.row.skuList" :key="i" :title="item.outerSkuName">
                    {{beautySub(item.outerSkuName,6)}}&nbsp;{{ item.skuId }}</div>
                </template>
              </el-table-column>
              <el-table-column label="原价" width="100" align="left">
                <template slot-scope="sc">
                  <div class="price-cell" v-for="(item,i) in  sc.row.skuList" :key="i">
                    <div class="price-current-line">
                      <span v-if="item.rrp > 0" class="price-current">{{ item.rrp }}</span>
                      <span v-if="item.rrp <= 0 || item.rrp == null" class="price-current price-empty">—</span>
                    </div>
                    <div v-if="item.rrp > 0" class="price-rate" :class="'price-rate-' + priceRateDirection(item.rrpRate)">
                      <span v-if="priceRateDirection(item.rrpRate) == 'up'" class="price-rate-icon">▲</span>
                      <span v-if="priceRateDirection(item.rrpRate) == 'down'" class="price-rate-icon">▼</span>
                      {{ formatPriceRate(item.rrpRate) }}
                    </div>
                    <span v-if="item.rrp > 0" class="price-previous" :class="{ 'price-empty': item.yesdayRrp <= 0 || item.yesdayRrp == null }">
                      {{ item.yesdayRrp > 0 ? item.yesdayRrp : '—' }}
                    </span>
                    <el-button v-if="item.rrp > 0 && (plat == 2 || plat == 5 || plat == 3)" type="text"
                      @click="editPrice(item)">编辑</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="去除国补到手价" width="140" align="left">
                <template slot-scope="sc">
                  <div class="price-cell" v-for="(item,i) in  sc.row.skuList" :key="i">
                    <div class="price-current-line">
                      <span v-if="item.finalPrice > 0" class="price-current">{{ item.finalPrice }}</span>
                      <span v-if="item.finalPrice <= 0 || item.finalPrice == null" class="price-current price-empty">—</span>
                    </div>
                    <div v-if="item.finalPrice > 0" class="price-rate" :class="'price-rate-' + priceRateDirection(item.finalPriceRate)">
                      <span v-if="priceRateDirection(item.finalPriceRate) == 'up'" class="price-rate-icon">▲</span>
                      <span v-if="priceRateDirection(item.finalPriceRate) == 'down'" class="price-rate-icon">▼</span>
                      {{ formatPriceRate(item.finalPriceRate) }}
                    </div>
                    <span v-if="item.finalPrice > 0" class="price-previous" :class="{ 'price-empty': item.yesdayFinalPrice <= 0 || item.yesdayFinalPrice == null }">
                      {{ item.yesdayFinalPrice > 0 ? item.yesdayFinalPrice : '—' }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="含国补到手价" width="140" align="left">
                <template slot-scope="sc">
                  <div class="price-cell" v-for="(item,i) in  sc.row.skuList" :key="i">
                    <div class="price-current-line">
                      <span v-if="item.predictedPrice > 0" class="price-current">{{ item.predictedPrice }}</span>
                      <span v-if="item.predictedPrice <= 0 || item.predictedPrice == null" class="price-current price-empty">—</span>
                      <div v-if="item.predictedPrice > 0&&item.isSubsidy==1"
                        style="width: 62px;height: 20px;color: #fff;margin-left: 4px;
                      line-height: 20px;text-align: center;background: #25BD7A;border-radius: 2px;display: inline-block;">
                        {{ item.subsidyText }}</div>
                    </div>
                    <div v-if="item.predictedPrice > 0" class="price-rate" :class="'price-rate-' + priceRateDirection(item.predictedPriceRate)">
                      <span v-if="priceRateDirection(item.predictedPriceRate) == 'up'" class="price-rate-icon">▲</span>
                      <span v-if="priceRateDirection(item.predictedPriceRate) == 'down'" class="price-rate-icon">▼</span>
                      {{ formatPriceRate(item.predictedPriceRate) }}
                    </div>
                    <span v-if="item.predictedPrice > 0" class="price-previous" :class="{ 'price-empty': item.yesdayPredictedPrice <= 0 || item.yesdayPredictedPrice == null }">
                      {{ item.yesdayPredictedPrice > 0 ? item.yesdayPredictedPrice : '—' }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="优惠信息" width="180" align="left">
                <template slot-scope="sc">
                  <div v-for="(item,i) in  sc.row.skuList" :key="i" :title="item.coupon" style="height: 46px; ">
                    <span style=""> {{ beautySub(item.coupon,12) }}</span>
                    <el-button type="text" v-if="item.coupon!=null&&plat==2||plat==5"
                      @click="edityhxx(item)">编辑</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="图片" width="280" align="left">
                <template slot-scope="sc">
                  <div v-for="(item,i) in sc.row.mainImageList" :key="i" style="margin-bottom: 4px;
                  display: flex;align-items: center;">
                    <div style="width: 20px;margin-right: 4px;">
                      <div v-if="item.isNew == 1" class="newIMG">新</div>
                    </div>
                    <el-image style="width: 54px; height: 40px" :src="item.imageUrl"
                      :preview-src-list="[item.imageUrl]">
                    </el-image>
                    <div :title="item.imageText">{{ beautySub(item.imageText,16) }}</div>
                  </div>

                  <el-button type="text" style="margin-left: 24px;" v-if="sc.row.mainImageList.length>0"
                    @click="openImg(sc.row.mainImageList)">编辑</el-button>
                </template>
              </el-table-column>
              <el-table-column label="物流信息" width="260" align="left">
                <template slot-scope="sc">
                  <div v-for="(item,i) in sc.row.logisticsList" :key="i">
                    <span>{{ item.cityName }}:{{item.logistics}}</span>
                  </div>
                  <el-button type="text" @click="editwuliu(sc.row)">编辑</el-button>
                </template>
              </el-table-column>
              <el-table-column label="运营" width="120" align="left">
                <template slot-scope="sc">
                  <span> {{ sc.row.operatorName }} </span>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="220" align="left">
                <template slot-scope="sc">
                  <el-popconfirm title="确认完成？" @confirm="sureOK(sc.row)">
                    <el-button type="text" slot="reference" v-if="sc.row.confirmStatus == 0">确认</el-button>
                  </el-popconfirm>
                  <span v-if="sc.row.confirmStatus==1" style="color: #999;"> 已确认 </span><br>
                  <span v-if="sc.row.confirmStatus==1" style="color: #999;">{{ sc.row.updateTime }}</span>
                  <br>

                </template>
              </el-table-column>
              <el-table-column label="商品更新时间" width="220" align="left">
                <template slot-scope="sc">
                  <span>{{ sc.row.updateTime }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="footer" v-if="total!=0">
              <a-pagination :default-current="page" :total="total" @change="changePage" v-if="total!=0" />
              <span>共 <label>{{ total }}</label>条</span>
            </div>
          </div>
        </div>

        <div class="dad" v-if="modulecheck==1" :style="{ height: `${screenHeight-60-12-12}px` }">
          <div class="dason">
            店铺评分更新
          </div>
          <div class="first-div">
            <el-select v-model="plat" placeholder="请选择" @change="getshop" size="mini"
              style="width: 100px;margin-right: 12px;">
              <el-option v-for="item in platArr" :key="item.code" :label="item.label" :value="item.code">
              </el-option>
            </el-select>
            <!-- <el-button size="mini" id="newAdd" @click="getshop">搜索</el-button> -->
          </div>
          <div class="two-table">
            <el-table :height="screenHeight-60-12-12-12-32-32-55-20" style="width: 100%" :data="shopData"
              class="custom-table" ref="mytable" :key="aaaaa">
              <el-table-column label="平台" width="80" align="center">
                <template slot-scope="sc">
                  <span v-if="sc.row.platform==1">京东</span>
                  <span v-if="sc.row.platform==2">天猫</span>
                  <span v-if="sc.row.platform==3">抖音</span>
                  <span v-if="sc.row.platform==4">小红书</span>
                  <span v-if="sc.row.platform==5">拼多多</span>
                </template>
              </el-table-column>
              <el-table-column label="客户店铺名称" align="left">
                <template slot-scope="sc">
                  <span :title="sc.row.storeName">{{ sc.row.storeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="店铺名称" align="left">
                <template slot-scope="sc">
                  <span :title="sc.row.outerStoreName">{{ sc.row.outerStoreName }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="plat==1?'店铺评分':plat==2?'店铺综合体验分':'店铺评分'" width="140" align="left">
                <template slot-scope="sc">
                  <div style="height: 28px;" v-if="sc.row.show== false">{{ sc.row.storeScore }}</div>
                  <el-input v-model="newstoreScore" placeholder="" style="width: 60px;" v-if="sc.row.show== true"
                    size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="plat==1?'物流履约分':plat==2?'物流速度分':'物流履约分'" width="140" align="left">
                <template slot-scope="sc">
                  <div style="height: 28px;" v-if="sc.row.show== false">{{ sc.row.deliveryScore }}</div>
                  <el-input v-model="newdeliveryScore" placeholder="" style="width: 60px;" v-if="sc.row.show== true"
                    size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="plat==1?'用户评价分':plat==2?'宝贝质量分':'用户评价分'" width="140" align="left">
                <template slot-scope="sc">
                  <div style="height: 28px;" v-if="sc.row.show== false">{{ sc.row.userReviewScore }}</div>
                  <el-input v-model="newuserReviewScore" placeholder="" style="width: 60px;" v-if="sc.row.show== true"
                    size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column v-if="plat!=2" label="售后服务分" width="140" align="left">
                <template slot-scope="sc">
                  <div style="height: 28px;" v-if="sc.row.show== false">{{ sc.row.afterSalesScore }}</div>
                  <el-input v-model="newafterSalesScore" placeholder="" style="width: 60px;" v-if="sc.row.show== true"
                    size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="plat==1?'客服咨询分':plat==2?'服务保障分':'客服咨询分'" width="140" align="left">
                <template slot-scope="sc">
                  <div style="height: 28px;" v-if="sc.row.show== false">{{ sc.row.customerServiceScore }}</div>
                  <el-input v-model="newcustomerServiceScore" placeholder="" style="width: 60px;"
                    v-if="sc.row.show== true" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="left">
                <template slot-scope="sc">
                  <el-button type="text" v-if="sc.row.show == false" @click="edit(sc.row,sc.$index)">编辑</el-button>
                  <el-button type="text" v-if="sc.row.show == true" @click="sureEdit(sc.row,sc.$index)">确认</el-button>
                  <el-button type="text" v-if="sc.row.show == true" @click="cancel(sc.row,sc.$index)">取消</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="footer" v-if="total!=0">
              <a-pagination :default-current="page" :total="total" @change="changePage2" v-if="total!=0" />
              <span>共 <label>{{ total }}</label>条</span>
            </div>
          </div>
        </div>

        <div class="dad" v-if="modulecheck==2" :style="{ height: `${screenHeight-60-12-12}px` }">
          <div class="dason">
            SKU匹配
          </div>
          <div class="first-div">
            <el-select v-model="plat" placeholder="请选择" size="mini" style="width: 100px;margin-right: 12px;">
              <el-option v-for="item in platArr" :key="item.code" :label="item.label" :value="item.code">
              </el-option>
            </el-select>
            <el-input v-model="searchskuId" clearable="" placeholder="请输入spuId" size="mini"
              style="width: 200px;"></el-input>
            <el-button size="mini" id="newAdd" @click="getSkudata">搜索</el-button>
          </div>
          <div class="two-table">
            <el-table :height="screenHeight-60-12-12-12-32-32-55-20" style="width: 100%" :data="skuData"
              class="custom-table" ref="mytable">
              <el-table-column label="客户SPU" width="140" align="left">
                <template slot-scope="sc">
                  <span>{{ sc.row.spuName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="商品ID" width="140" align="left">
                <template slot-scope="sc">
                  <span>{{ sc.row.spuId }}</span>
                </template>
              </el-table-column>
              <el-table-column label="客户SKU" align="left">
                <template slot-scope="sc">
                  <span>{{ sc.row.skuName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="SKUID" width="140" align="left">
                <template slot-scope="sc">
                  <span>{{ sc.row.skuId }}</span>
                </template>
              </el-table-column>
              <el-table-column label="SKU名称" align="left" :key="aaaaa">
                <template slot-scope="sc">
                  <div style="height: 28px;" v-if="sc.row.show== false">{{ sc.row.outerSkuName }}</div>
                  <el-select v-model="skuName" placeholder="请选择" v-if="sc.row.show== true" size="mini">
                    <el-option v-for="item in skuNameList" :key="item.skuId" :label="item.outerSkuName"
                      :value="item.skuId">
                    </el-option>
                  </el-select>
                  <el-button type="text" v-if="sc.row.show== true" @click="sureSkuName(sc.row,sc.$index)">确认</el-button>
                  <el-button type="text" v-if="sc.row.show== true"
                    @click="cancelSkuName(sc.row,sc.$index)">取消</el-button>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="120" align="left">
                <template slot-scope="sc">
                  <el-button type="text" @click="opSkuName(sc.row,sc.$index)">设置SKU名称</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="footer" v-if="total!=0">
              <a-pagination :default-current="page" :total="total" @change="changePage3" v-if="total!=0" />
              <span>共 <label>{{ total }}</label>条</span>
            </div>
          </div>
        </div>

        <div class="dad" v-if="modulecheck==3" :style="{ height: `${screenHeight-60-12-12}px` }">
          <div class="dason">
            SKU匹配
          </div>
          <div class="first-div">
            <el-select v-model="plat" placeholder="请选择" size="mini" style="width: 100px;margin-right: 12px;">
              <el-option v-for="item in platArr" :key="item.code" :label="item.label" :value="item.code">
              </el-option>
            </el-select>
            <el-input v-model="spuID" clearable="" placeholder="请输入spuId" size="mini" style="width: 200px;"></el-input>
            <el-button size="mini" id="newAdd" @click="getspulistsearch">搜索</el-button>
            <el-button size="mini" id="newAdd22" style="float: right;" @click="addnewOpre">新增运营人员</el-button>
          </div>
          <div class="two-table">
            <el-table :height="screenHeight-60-12-12-12-32-32-55-20" style="width: 100%" :data="opreData"
              class="custom-table" ref="mytable">
              <el-table-column label="客户SPU" width="240" align="left">
                <template slot-scope="sc">
                  <span>{{ sc.row.spuName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="商品ID" width="200" align="left">
                <template slot-scope="sc">
                  <span>{{ sc.row.spuId }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平台" align="left">
                <template slot-scope="sc">
                  <span v-if="sc.row.platform == 1">京东</span>
                  <span v-if="sc.row.platform == 2">天猫</span>
                  <span v-if="sc.row.platform == 3">抖音</span>
                  <span v-if="sc.row.platform == 4">小红书</span>
                  <span v-if="sc.row.platform == 5">拼多多</span>

                </template>
              </el-table-column>
              <el-table-column label="运营" align="left" :key="aaaaa">
                <template slot-scope="sc">
                  <div style="height: 28px;" v-if="sc.row.show== false">{{ sc.row.operatorName }}</div>
                  <el-select v-model="spuName" placeholder="请选择" v-if="sc.row.show== true" size="mini">
                    <el-option v-for="item in spuNameList" :key="item.operatorId" :label="item.operatorName"
                      :value="item.operatorName">
                    </el-option>
                  </el-select>
                  <el-button type="text" v-if="sc.row.show== true" @click="sureSpuName(sc.row,sc.$index)">确认</el-button>
                  <el-button type="text" v-if="sc.row.show== true"
                    @click="cancelSpuName(sc.row,sc.$index)">取消</el-button>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="120" align="left">
                <template slot-scope="sc">
                  <el-button type="text" @click="opSpuName(sc.row,sc.$index)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="footer" v-if="total!=0">
              <a-pagination :default-current="page" :total="total" @change="changePage4" v-if="total!=0" />
              <span>共 <label>{{ total }}</label>条</span>
            </div>
          </div>
        </div>
        <el-dialog title="图片" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false"
          :before-close="handleClose" class="myimgdialog">
          <div class="img_dialog" v-if="dialogVisible">
            <div v-if="imgArr.length>0">
              <img :src="imgArr[0].imageUrl" @click="checkImg($event,0)" class="diaimg" />
            </div>
            <div v-if="imgArr.length>1">
              <img :src="imgArr[1].imageUrl" @click="checkImg($event,1)" class="diaimg" />
            </div>
            <div v-if="imgArr.length>2">
              <img :src="imgArr[2].imageUrl" @click="checkImg($event,2)" class="diaimg" />
            </div>
          </div>
          <div style="margin-top: 12px;display: flex;" v-if="imgIndex==0">
            <div><el-image style="width: 400px; height: 400px" :src="imgBigShow" :preview-src-list="[imgBigShow]">
              </el-image></div>
            <div style="width: 160%;">
              <el-form ref="form" label-width="100px">
                <el-form-item label="图1：">
                  <el-autocomplete class="inline-input" v-for="(item,i) in imgTextArr1" :key="i" v-model="item.text"
                    style="width: 80%;margin-bottom: 12px;" :fetch-suggestions="querySearch" placeholder="请输入内容"
                    :trigger-on-focus="false" @select="handleSelect"></el-autocomplete>

                  <el-button type="text" style="font-size: 12px;margin-left: 8px; color: #0099ff;"
                    @click="addText(1)">新增</el-button>
                  <el-button type="text" v-if="imgTextArr1.length>1"
                    style="font-size: 12px;margin-left: 8px; color: #0099ff;" @click="deleteText(1)">删除</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div style="margin-top: 12px;display: flex;" v-if="imgIndex==1">
            <div>
              <el-image style="width: 400px; height: 400px" :src="imgBigShow" :preview-src-list="[imgBigShow]">
              </el-image>
            </div>
            <div style="width: 160%;">
              <el-form ref="form" label-width="100px">
                <el-form-item label="图2：">
                  <el-autocomplete class="inline-input" v-for="(item,i) in imgTextArr2" :key="i" v-model="item.text"
                    style="width: 80%;margin-bottom: 12px;" :fetch-suggestions="querySearch" placeholder="请输入内容"
                    :trigger-on-focus="false" @select="handleSelect"></el-autocomplete>
                  <el-button type="text" style="font-size: 12px;margin-left: 8px; color: #0099ff;"
                    @click="addText(2)">新增</el-button>
                  <el-button type="text" v-if="imgTextArr2.length>1"
                    style="font-size: 12px;margin-left: 8px; color: #0099ff;" @click="deleteText(2)">删除</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div style="margin-top: 12px;display: flex;" v-if="imgIndex==2">
            <div><el-image style="width: 400px; height: 400px" :src="imgBigShow" :preview-src-list="[imgBigShow]">
              </el-image></div>
            <div style="width: 160%;">
              <el-form ref="form" label-width="100px">
                <el-form-item label="图3：">
                  <el-autocomplete class="inline-input" v-for="(item,i) in imgTextArr3" :key="i" v-model="item.text"
                    style="width: 80%;margin-bottom: 12px;" :fetch-suggestions="querySearch" placeholder="请输入内容"
                    :trigger-on-focus="false" @select="handleSelect"></el-autocomplete>
                  <el-button type="text" style="font-size: 12px;margin-left: 8px; color: #0099ff;"
                    @click="addText(3)">新增</el-button>
                  <el-button type="text" v-if="imgTextArr3.length>1"
                    style="font-size: 12px;margin-left: 8px; color: #0099ff;" @click="deleteText(3)">删除</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="editMainImageText">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="价格修改" :visible.sync="priceShow" width="40%" :close-on-click-modal="false"
          :before-close="handleClose2">
          <el-form ref="form" label-width="140px">
            <el-form-item label="原价：">
              <el-input v-model="priceData.rrp"></el-input>
            </el-form-item>
            <el-form-item label="去除国补到手价：">
              <el-input v-model="priceData.finalPrice"></el-input>
            </el-form-item>
            <el-form-item label="含国补到手价：">
              <el-input v-model="priceData.predictedPrice"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="priceShow = false">取 消</el-button>
            <el-button type="primary" @click="sureEditPrice">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="优惠信息" :visible.sync="yhxxShow" width="30%" :close-on-click-modal="false"
          :before-close="handleClose3">
          <div class="myyhxxDiv">
            <div v-for="(item,i) in yhxxTextList" :key="i"><el-button plain id="myyhBT"
                @click="addmyyhxx(item)">{{ item }}</el-button></div>
          </div>

          <el-form ref="form" label-width="40px">
            <el-form-item label="">
              <el-input v-model="yhxx" type="textarea" :rows="5"></el-input>
            </el-form-item>

          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="yhxxShow = false">取 消</el-button>
            <el-button type="primary" @click="sureEdityhxx">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="物流信息" :visible.sync="wuliu" width="40%" :close-on-click-modal="false"
          :before-close="handleClose4">
          <el-form ref="form" label-width="140px">
            <el-form-item v-for="(item,i) in wuliuarr.logisticsList" :key="i" :label="item.cityName+'：'">
              <el-input v-model="item.logistics"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="wuliu = false">取 消</el-button>
            <el-button type="primary" @click="sureEditwuliu">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="新增运营人员" :visible.sync="addnewOpreShow" width="40%" :close-on-click-modal="false"
          :before-close="handleClose4">
          <el-form ref="form" label-width="140px">
            <el-form-item label="所属平台：">
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="2">天猫</el-checkbox>
                <el-checkbox label="1">京东</el-checkbox>
                <el-checkbox label="3">抖音</el-checkbox>
                <el-checkbox label="4">小红书</el-checkbox>
                <el-checkbox label="5">拼多多</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="姓名：">
              <el-input v-model="newopreName" style="width: 240px;" size="mini" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addnewOpreShow = false">取 消</el-button>
            <el-button type="primary" @click="sureEditnewOper">确 定</el-button>
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import {
  confirmStatus, platform, getlist, editPrice, editMainImageText, editCoupon, editLogistics
  , sureconfirm, refresh, scorelist, scoreedit, skulist, skuNamelist, skuNameedit, suggestMainImageText
  , operatoradd, operatorlist, spulist, operatorassign, operatorName
} from "../api/index"
import { Message } from 'element-ui';
export default {
  name: 'indexPage',
  data () {
    return {
      newopreName: '',
      checkList: [],
      addnewOpreShow: false,
      spuNameList: [],
      spuName: '',
      spuID: '',
      opreData: [],
      restaurants: [],
      yhxxTextList: ['下单返9折券', '国家贴息', '3期免息', '6期免息', '12期免息', '24期息费3折'],
      newstoreScore: '',
      newuserReviewScore: '',
      newafterSalesScore: '',
      newcustomerServiceScore: '',
      newdeliveryScore: '',
      aaaaa: 0,
      shopData: [],
      skuNameList: [],
      skuName: '',
      skuData: [],
      searchskuId: '',
      modulecheck: 0,
      asideList: [
        { label: '价格', icon: 'cate', path: 'number' },
        { label: '店铺', icon: 'store', path: 'shop' },
        { label: 'SKU', icon: 'layout', path: 'shop' },
        { label: '运营', icon: 'archive', path: 'shop' },
      ],
      wuliuarr: {},
      yhxxarr: {},
      yhxxShow: false,
      yhxx: '',
      imgIndex: 0,
      imgTextArr1: [],
      imgTextArr2: [],
      imgTextArr3: [],
      wuliu: false,
      imgBigShow: '',
      priceData: {},
      priceShow: false,
      dialogVisible: false,
      stateArr: [],
      platArr: [],
      operatorArr: [],
      states: '',
      plat: '',
      operator: '',
      spuId: '',
      screenHeight: document.body.clientHeight,
      tableData: [],
      imgArr: [],
      date: '',
      editingCell: '',
      newuserName: '',
      page: 1,
      total: 0,
      cookie1: '',
      expireTimeOPtion: {
        disabledDate (time) {
          return time.getTime() > Date.now();  //如果没有后面的-8.64e7就是不可以选择今天的 
        }
      },
    };
  },

  methods: {
    Message,
    getspulistsearch () {
      this.page = 1
      this.getspulist()
    },
    sureEditnewOper () {
      let raw = {
        "operatorName": this.newopreName,
        "platform": this.checkList
      }
      operatoradd(raw).then(res => {
        if (res.data.code == '200') {
          this.Message({
            message: res.data.message,
            type: 'success'
          })
          this.newopreName = ''
          this.checkList = []
          this.addnewOpreShow = false
          this.getspulist()
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    addnewOpre () {
      this.addnewOpreShow = true
    },
    sureSpuName (sc, i) {
      console.log(sc, i)
      let raw = {
        "operatorName": this.spuName,
        "platform": this.plat,
        "spuId": sc.spuId
      }
      operatorassign(raw).then(res => {
        if (res.data.code == '200') {
          this.getspulist()
          this.Message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    cancelSpuName (sc, i) {
      console.log(sc, i)
      this.spuName = ''
      this.$nextTick(() => {
        this.$set(this.opreData[i], 'show', false)
      })
      this.aaaaa++
      this.$forceUpdate()
    },
    opSpuName (r, i) {
      this.getoperatorlist()
      this.$nextTick(() => {
        this.$set(this.opreData[i], 'show', true)
      })
      this.aaaaa++
      this.$forceUpdate()
    },
    getspulist () {
      let raw = {
        "page": this.page,
        "pageSize": 10,
        "platform": this.plat,
        "spuId": this.spuID
      }
      spulist(raw).then(res => {
        if (res.data.code == '200') {
          this.opreData = res.data.data.records
          this.total = parseInt(res.data.data.recordTotal)
          this.opreData.forEach((item, i) => {
            item.show = false,
              item.myid = i

          })
        }
      })
    },
    getoperatorlist () {
      let raw = {
        "platform": this.plat
      }
      operatorlist(raw).then(res => {
        if (res.data.code == '200') {
          this.spuNameList = res.data.data
        }
      })
    },
    handleSelect (item) {
      console.log(item);

    },
    querySearch (queryString, cb) {

      this.suggestMainImageText(queryString)
      setTimeout(() => {
        cb([]);
        var restaurants = this.restaurants;
        // 调用 callback 返回建议列表的数据
        //console.log(restaurants)
        cb(restaurants);
      }, 1000);

    },
    suggestMainImageText (queryString) {
      let raw = {
        "word": queryString
      }
      suggestMainImageText(raw).then(res => {

        if (res.data.code == '200') {
          this.restaurants = []
          res.data.data.suggestWordResult.forEach(item => {
            this.restaurants.push({ 'value': item })
          })
          // this.restaurants = res.data.data.suggestWordResult
          // console.log(this.restaurants)
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })

    },
    sureSkuName (sc, i) {
      console.log(sc, i)
      let raw = {
        "id": sc.id,
        "skuId": this.skuName
      }
      skuNameedit(raw).then(res => {
        if (res.data.code == '200') {
          this.getSkudata()
          this.Message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    cancelSkuName (sc, i) {
      console.log(sc, i)
      this.skuName = ''
      this.$nextTick(() => {
        this.$set(this.skuData[i], 'show', false)
      })
      this.aaaaa++
      this.$forceUpdate()
    },
    getSkudata () {
      let raw = {
        "page": this.page,
        "pageSize": 10,
        "platform": this.plat,
        "spuId": this.searchskuId
      }

      skulist(raw).then(res => {
        if (res.data.code == 200) {
          this.skuData = res.data.data.records
          console.log(this.skuData)
          this.total = parseInt(res.data.data.recordTotal)
          this.skuData.forEach((item, i) => {
            item.show = false,
              item.myid = i

          })
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })

    },
    opSkuName (sc, i) {
      let raw = {
        "platform": this.plat,
        "spuId": sc.spuId
      }
      skuNamelist(raw).then(res => {
        if (res.data.code == '200') {
          this.skuNameList = res.data.data
          this.skuName = ''
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
      this.$nextTick(() => {
        this.$set(this.skuData[i], 'show', true)
      })
      this.aaaaa++
      this.$forceUpdate()


    },
    addmyyhxx (item) {
      this.yhxx += item
    },
    cancel (row, i) {
      this.$nextTick(() => {
        this.$set(this.shopData[i], 'show', false)
      })
      this.aaaaa++
      this.$forceUpdate()
    },
    sureEdit (row, i) {
      let raw = {
        "afterSalesScore": this.newafterSalesScore,
        "customerServiceScore": this.newcustomerServiceScore,
        "deliveryScore": this.newdeliveryScore,
        "platform": row.platform,
        "storeName": row.storeName,
        "storeScore": this.newstoreScore,
        "userReviewScore": this.newuserReviewScore
      }
      scoreedit(raw).then(res => {
        if (res.data.code == 200) {
          this.Message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
        this.newafterSalesScore = ''
        this.newcustomerServiceScore = ''
        this.newdeliveryScore = ''
        this.newstoreScore = ''
        this.newuserReviewScore = ''
        this.getshopData()
        this.$nextTick(() => {
          this.$set(this.shopData[i], 'show', false)
        })
        this.aaaaa++
        this.$forceUpdate()
      })

    },
    edit (row, i) {
      //console.log(row)
      this.$nextTick(() => {
        this.$set(this.shopData[i], 'show', true)
      })
      this.aaaaa++
      this.$forceUpdate()

    },
    getshop () {
      this.page = 1
      this.getshopData()
    },
    getshopData () {
      let raw = {
        "page": this.page,
        "pageSize": 10,
        "platform": this.plat
      }
      scorelist(raw).then(res => {
        if (res.data.code == 200) {
          this.shopData = res.data.data.records
          this.total = parseInt(res.data.data.recordTotal)
          this.shopData.forEach((item, i) => {
            item.show = false,
              item.myid = i
            // item.newafterSalesScore = '',
            //   item.newcustomerServiceScore = '',
            //   item.newdeliveryScore = '',
            //   item.newstoreScore = '',
            //   item.newuserReviewScore = ''
          })
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
        //console.log(this.shopData)
      })
    },
    //鼠标悬停
    checkDayhandleMouseOver (e) {
      if (e.srcElement.localName != 'use' && e.srcElement.localName != 'svg') {
        e.srcElement.className += ' dayready'
      } else if (e.srcElement.localName == 'use') {
        e.srcElement.parentElement.parentElement.className += ' dayready'
      } else if (e.srcElement.localName == 'svg') {
        e.srcElement.parentElement.className += ' dayready'
      } else if (e.srcElement.localName == 'span') {
        e.srcElement.parentElement.className += ' dayready'
      }

    },
    //鼠标离开
    checkDayhandleMouseOut (e) {
      if (e.srcElement.localName != 'use' && e.srcElement.localName != 'svg') {
        e.srcElement.className = e.srcElement.className.replace(" dayready", "");
      } else if (e.srcElement.localName == 'use') {
        e.srcElement.parentElement.parentElement.className = e.srcElement.parentElement.parentElement.className.replace(" dayready", "");
      } else if (e.srcElement.localName == 'svg') {
        e.fromElement.parentElement.className = e.fromElement.parentElement.className.replace(" dayready", "");
      } else if (e.srcElement.localName == 'span') {
        e.srcElement.parentElement.className = e.fromElement.parentElement.className.replace(" dayready", "")
      }
    },
    checkDay (e, index) {
      this.modulecheck = index
      localStorage.setItem('modulecheck', index)
      this.plat = ''
      this.operator = ''
      this.page = 1
      this.shopData = []
      this.tableData = []
      this.skuData = []
      this.skuNameList = []
      this.skuName = ''
      this.date = ''
      this.states = ''
      this.total = 0
      if (index == 1) {
        // this.query()
      }
      for (let i = 0; i < this.$refs.dayorlive.length; i++) {
        this.$refs.dayorlive[i].className = 'aside-dayorlive'
      }
      if (e.srcElement.localName == 'span' || e.srcElement.localName == 'svg') {
        e.srcElement.parentElement.className = 'aside-dayorlive dayactive'
      } else if (e.srcElement.localName == 'use') {
        e.srcElement.parentElement.parentElement.className = 'aside-dayorlive dayactive'
      } else {
        e.srcElement.className = 'aside-dayorlive dayactive'
      }

    },
    copyText (r) {
      //console.log(r)
      // 方法1：使用 navigator.clipboard
      if (r.productUrl == null) {
        this.Message({
          message: '暂无链接！！！',
          type: 'error'
        })
        return
      }
      navigator.clipboard.writeText(r.productUrl)
        .then(() => {
          this.Message({
            message: '复制成功！',
            type: 'success'
          })
        })
        .catch(err => {
          console.log('复制失败：', err);
          this.Message({
            message: '复制失败',
            type: 'error'
          })
        })
    },
    reflash (r) {
      let raw = {
        "platform": this.plat,
        "spuId": r.spuId
      }
      refresh(raw).then(res => {
        if (res.data.code == 200) {
          this.getData()
          this.Message({
            message: '刷新成功！',
            type: 'success'
          })


        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    sureOK (r) {
      console.log(r)
      let raw = {
        "dataDate": this.date,
        "platform": this.plat,
        "spuId": r.spuId
      }
      let issend = 1
      r.skuList.forEach(item => {
        if (parseInt(item.isOnline) == 1 && parseInt(r.isOnline) == 1) {
          if (parseInt(item.finalPrice) == 0 || parseInt(item.rrp) == 0 || parseInt(item.predictedPrice) == 0) {
            issend = 0
            this.Message({
              message: '请完善价格！',
              type: 'error'
            })
            return
          }
        }
      })

      setTimeout(() => {
        if (issend == 1) {
          sureconfirm(raw).then(res => {
            if (res.data.code == 200) {
              this.getData()
              this.Message({
                message: '确认成功！',
                type: 'success'
              })
            } else {
              this.Message({
                message: res.data.message,
                type: 'error'
              })
            }
          })
        }
      }, 700);
    },
    sureEditwuliu () {
      let raw = {
        "dataDate": this.date,
        "logisticsBj": this.wuliuarr.logisticsList[3].logistics,
        "logisticsCd": this.wuliuarr.logisticsList[1].logistics,
        "logisticsSh": this.wuliuarr.logisticsList[2].logistics,
        "logisticsSz": this.wuliuarr.logisticsList[0].logistics,
        "platform": this.plat,
        "spuId": this.wuliuarr.logisticsList[0].spuId
      }
      editLogistics(raw).then(res => {
        if (res.data.code == 200) {
          this.wuliu = false
          this.getData()
          this.Message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    editwuliu (sc) {
      //console.log(sc)
      this.wuliu = true
      this.wuliuarr = sc
    },
    sureEdityhxx () {
      let raw = {
        "coupon": this.yhxx,
        "dataDate": this.date,
        "platform": this.plat,
        "spuId": this.yhxxarr.spuId,
        "skuId": this.yhxxarr.skuId
      }
      editCoupon(raw).then(res => {
        if (res.data.code == 200) {
          this.yhxxShow = false
          this.getData()
          this.Message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    edityhxx (r) {
      this.yhxxShow = true
      this.yhxxarr = r
      this.yhxx = r.coupon
      console.log(r)
    },
    editMainImageText () {
      let textArr = ''
      let textArr2 = ''
      let textArr3 = ''
      let raw = []

      this.imgTextArr1.forEach(item => {

        if (item.text != '') {
          textArr += item.text + ';'
        }

      })
      this.imgTextArr2.forEach(item => {
        if (item.text != '') {
          textArr2 += item.text + ';'
        }
      })
      this.imgTextArr3.forEach(item => {
        if (item.text != '') {
          textArr3 += item.text + ';'
        }
      })
      if (this.imgArr.length == 1) {
        raw = [
          {
            "imageId": this.imgArr[0].imageId,
            "imageText": textArr,
          }
        ]
      }
      if (this.imgArr.length == 2) {
        raw = [
          {
            "imageId": this.imgArr[0].imageId,
            "imageText": textArr,
          },
          {
            "imageId": this.imgArr[1].imageId,
            "imageText": textArr2,
          },

        ]
      }
      if (this.imgArr.length == 3) {
        raw = [
          {
            "imageId": this.imgArr[0].imageId,
            "imageText": textArr,
          },
          {
            "imageId": this.imgArr[1].imageId,
            "imageText": textArr2,
          },
          {
            "imageId": this.imgArr[2].imageId,
            "imageText": textArr3,
          },
        ]
      }
      editMainImageText(raw).then(res => {
        if (res.data.code == 200) {
          this.dialogVisible = false
          this.Message({
            message: '修改成功',
            type: 'success'
          })
          this.getData()
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    deleteText (i) {
      if (i == 1) {
        this.imgTextArr1.splice(this.imgTextArr1.length - 1, 1)
      }

      if (i == 2) {
        this.imgTextArr2.splice(this.imgTextArr2.length - 1, 1)
      }

      if (i == 3) {
        this.imgTextArr3.splice(this.imgTextArr3.length - 1,)
      }
    },
    addText (i) {
      if (i == 1) {
        if (this.imgTextArr1.length >= 10) {
          return
        } else {
          this.imgTextArr1.push({ text: '' })
        }
      }

      if (i == 2) {
        if (this.imgTextArr2.length >= 10) {
          return
        } else {
          this.imgTextArr2.push({ text: '' })
        }
      }

      if (i == 3) {
        if (this.imgTextArr3.length >= 10) {
          return
        } else {
          this.imgTextArr3.push({ text: '' })
        }
      }


    },
    sureEditPrice () {
      let raw = {
        "dataDate": this.date,
        "finalPrice": this.priceData.finalPrice,
        "platform": this.plat,
        "predictedPrice": this.priceData.predictedPrice,
        "rrp": this.priceData.rrp,
        "skuId": this.priceData.skuId,
        "spuId": this.priceData.spuId
      }
      console.log(this.priceData.rrp, this.priceData.finalPrice)
      if (parseFloat(this.priceData.rrp) < parseFloat(this.priceData.finalPrice)) {
        this.$message.error('原价不能小于去除国补到手价')
        return
      }
      if (parseFloat(this.priceData.predictedPrice) > parseFloat(this.priceData.finalPrice)) {
        this.$message.error('去除国补到手价必须大于等于含国补价到手价')
        return
      }


      editPrice(raw).then(res => {
        //console.log(res)
        if (res.data.code == 200) {
          this.priceShow = false
          this.Message({
            message: '修改成功',
            type: 'success'
          })
          this.getData()
        } else {
          this.Message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    editPrice (item) {
      this.priceShow = true
      this.priceData = item
      //console.log(item)
    },
    myplatform () {
      platform().then(res => {
        this.platArr = res.data.data
        //console.log(res)
      })
    },
    myconfirmStatus () {
      confirmStatus().then(res => {
        this.stateArr = res.data.data
        //console.log(res)
      })
    },
    myOperatorName (platform = 0) {
      this.operator = ''
      this.operatorArr = []
      operatorName({ platform: platform || 0 }).then(res => {
        if (res.data.code) {
          this.operatorArr = (res.data.data || []).map(item => {
            if (typeof item === 'string') {
              return { code: item, label: item }
            }
            return {
              code: item.code != null ? item.code : item.operatorName != null ? item.operatorName : item.operatorId,
              label: item.label != null ? item.label : item.operatorName != null ? item.operatorName : item.code
            }
          })
        }
      })
    },
    checkImg (e, i) {
      this.imgIndex = i
      if (i == 0) {
        e.srcElement.className = 'diaimg checkimg'
        document.querySelectorAll('.diaimg')[1].className = 'diaimg'
        document.querySelectorAll('.diaimg')[2].className = 'diaimg'
      } else if (i == 1) {
        e.srcElement.className = 'diaimg checkimg'
        document.querySelectorAll('.diaimg')[0].className = 'diaimg'
        document.querySelectorAll('.diaimg')[2].className = 'diaimg'
      } else if (i == 2) {
        e.srcElement.className = 'diaimg checkimg'
        document.querySelectorAll('.diaimg')[0].className = 'diaimg'
        document.querySelectorAll('.diaimg')[1].className = 'diaimg'
      }
      this.imgBigShow = this.imgArr[i].imageUrl
    },
    handleClose () {
      this.dialogVisible = false
      this.imgTextArr1 = [{ text: '' }]
      this.imgTextArr2 = [{ text: '' }]
      this.imgTextArr3 = [{ text: '' }]
    },
    handleClose2 () {
      this.priceShow = false
      this.priceData = {}
    },
    handleClose3 () {
      this.yhxxShow = false
      this.yhxxarr = {}
    },
    handleClose4 () {
      this.imgIndex = 0
      this.wuliu = false
      this.wuliuarr = {}
    },
    openImg (e) {
      console.log(e)
      this.imgBigShow = e[0].imageUrl
      this.imgIndex = 0
      this.imgTextArr1 = []
      this.imgTextArr2 = []
      this.imgTextArr3 = []

      e.forEach((item, i) => {
        if (i == 0 && item.imageText != null) {
          let isarr = item.imageText.split(';')
          isarr.forEach(dad => {
            this.imgTextArr1.push({ text: dad })
          })
        } else if (i == 1 && item.imageText != null) {
          let isarr = item.imageText.split(';')
          isarr.forEach(dad => {
            this.imgTextArr2.push({ text: dad })
          })
        } else if (i == 2 && item.imageText != null) {
          let isarr = item.imageText.split(';')
          isarr.forEach(dad => {
            this.imgTextArr3.push({ text: dad })
          })
        }

      })
      this.imgArr = e
      this.dialogVisible = true
    },
    changePage (current) {
      this.page = current
      this.getData()
    },
    changePage2 (current) {
      this.page = current
      this.getshopData()
    },
    changePage3 (current) {
      this.page = current
      this.getSkudata()
    },
    changePage4 (current) {
      this.page = current
      this.getspulist()
    },
    search () {
      this.page = 1
      this.getData()
    },
    getData () {

      this.tableData = []
      let raw = {
        "beginTime": this.date,
        "confirmStatus": this.states,
        "page": this.page,
        "pageSize": 10,
        "platform": this.plat,
        "operatorName": this.operator,
        "spuId": this.spuId
      }
      // let raw = {
      //   beginTime: "2026-04-16",
      //   confirmStatus: null,
      //   page: 1,
      //   pageSize: 10,
      //   platform: 1,
      //   spuId: "10129877489172"
      // }
      getlist(raw).then(res => {
        //console.log(res.data.data.records)
        if (res.data.code) {
          this.tableData = res.data.data.records
          this.tableData.forEach(item => {
            item.imgArr = []
          })
          this.tableData.forEach(item => {
            item.mainImageList.forEach(e => {
              item.imgArr.push(e.imageUrl)
            })

          })
          this.total = parseInt(res.data.data.recordTotal)
        } else {
          Message.error(res.data.message)
        }

      })


    },
    priceRateDirection (rate) {
      if (rate == null) {
        return 'neutral'
      }
      let text = String(rate).trim()
      if (text.indexOf('▲') >= 0) {
        return 'up'
      }
      if (text.indexOf('▼') >= 0) {
        return 'down'
      }
      if (text == '-' || text == '') {
        return 'neutral'
      }
      let value = parseFloat(text.replace('%', ''))
      if (isNaN(value) || value == 0) {
        return 'neutral'
      }
      return value > 0 ? 'up' : 'down'
    },
    formatPriceRate (rate) {
      if (rate == null || String(rate).trim() == '') {
        return '-'
      }
      let text = String(rate).trim()
      if (text == '-') {
        return text
      }
      text = text.replace(/[▲▼]/g, '').trim()
      return text.charAt(0) == '-' || text.charAt(0) == '+' ? text.substring(1) : text
    },
    beautySub (str, len) {
      if (str == null) {
        return str
      }
      if (str.length == 0) {
        return str
      }
      var reg = /[\u4e00-\u9fa5]/g,    //专业匹配中文
        slice = str.substring(0, len),
        chineseCharNum = (~~(slice.match(reg) && slice.match(reg).length)),
        realen = slice.length * 2 - chineseCharNum;
      return str.substr(0, realen) + (realen < str.length ? "..." : "");
    },
  },
  watch: {

    screenHeight (val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenHeight = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    }
  },
  mounted () {
    if (localStorage.getItem('modulecheck') == '1') {
      this.$refs.dayorlive[1].className = 'aside-dayorlive dayactive'
      this.modulecheck = 1
    } else if (localStorage.getItem('modulecheck') == '2') {
      this.$refs.dayorlive[2].className = 'aside-dayorlive dayactive'
      this.modulecheck = 2

    } else {
      this.$refs.dayorlive[0].className = 'aside-dayorlive dayactive'
    }

    this.myplatform()
    this.myconfirmStatus()
    this.myOperatorName()
    this.modulecheck = localStorage.getItem('modulecheck')
    this.$refs.dayorlive[this.modulecheck].className = 'aside-dayorlive dayactive'
    const that = this
    window.onresize = () => {
      return (() => {
        // 可以限制最小高度
        // if (document.body.clientHeight - 240 < 450) {
        //   return
        // }
        window.screenHeight = document.body.clientHeight
        that.screenHeight = window.screenHeight
      })()
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #0099ff;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #0099ff !important;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0099ff;
}
/deep/.el-checkbox__label {
  padding-left: 4px;
}
/deep/.el-checkbox {
  margin-right: 12px;
}
.ddddd {
  img:nth-child(2) {
    position: absolute;
    left: 258px;
    top: 705px;
    width: 770px;
    height: 325px;
    border-radius: 8px;
  }
}
.newIMG {
  width: 20px;
  height: 20px;
  line-height: 19px;
  border-radius: 10px;
  background-color: #e82d2d;
  color: #ffffff;
  text-align: center;
  margin-bottom: 0px;
  border: 1px solid #e82d2d;
}
.price-cell {
  height: 72px;
  line-height: 20px;
  white-space: nowrap;
}
.sku-cell {
  height: 72px;
  line-height: 20px;
}
.price-current-line {
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
}
.price-current {
  color: #e82d2d;
}
.price-empty {
  color: #e82d2d;
  visibility: hidden;
}
.price-rate {
  display: block;
  height: 20px;
  line-height: 20px;
}
.price-rate-icon {
  margin-right: 2px;
}
.price-rate-up {
  color: #e82d2d;
}
.price-rate-down {
  color: #25bd7a;
}
.price-rate-neutral {
  color: #999999;
  visibility: hidden;
}
.price-previous {
  display: block;
  height: 20px;
  line-height: 20px;
  color: #999999;
}
/deep/.myyhxxDiv {
  display: flex;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  #myyhBT {
    margin-bottom: 8px;
  }
}
/deep/.myimgdialog {
  .el-dialog__body {
    padding-top: 0px;
  }
  .img_dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      margin: 0px 6px;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
  .checkimg {
    border: 4px solid #227cfa;
    transform: 0.3s;
  }
  .diaimg:hover {
    border: 4px solid #227cfa;
  }
}
.custom-table /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  height: 15px; /* 控制横向滚动条的“粗细”/高度，默认约 6-8px，改为 15px 即可明显加粗 */
}
/deep/.el-table .el-table__cell {
  vertical-align: top;
  .el-button--text {
    padding: 0px;
    color: #0099ff;
    font-size: 12px;
  }
}
/* 可选：同时自定义滑块的颜色和圆角，让加粗后的滚动条更美观 */
.custom-table /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1; /* 滑块颜色 */
  border-radius: 5px; /* 滑块圆角 */
}

.custom-table /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f5f5f5; /* 轨道背景色 */
  border-radius: 5px;
}
.custom-table /deep/ .el-table__fixed {
  height: auto !important;
  bottom: 15px !important; /* 这里的数值建议与你上面设置的滚动条 height 保持一致 */
}

.custom-table /deep/ .el-table__fixed-right {
  height: auto !important;
  bottom: 10px !important; /* 右侧固定列同理 */
  right: 0px !important; /* 避免右侧固定列遮挡滚动条 */
}
.dad {
  background-color: #fff;

  .dason {
    padding-left: 32px;
    margin-bottom: 12px;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    height: 48px;
    line-height: 48px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 0px #e8e8e8;
  }
}
.first-div {
  height: 32px;
  margin: 24px 32px 12px 24px;
  #newAdd {
    width: 58px;
    height: 32px;
    background: #0099ff;
    border-radius: 6px;
    color: #fff;
    margin-left: 12px;
  }
  #newAdd22 {
    width: 108px;
    height: 32px;
    background: #0099ff;
    border-radius: 6px;
    color: #fff;
    margin-left: 12px;
  }
}
.two-table {
  padding: 0px 32px 12px 32px;
  .footer {
    z-index: 10;
    position: fixed;
    bottom: 0px;
    width: calc(100% - 82px);
    height: 55px;
    line-height: 55px;
    background: #ffffff !important;
    border-top: 1px solid #eee;
    right: 0px;
    border-radius: 0px 0px 8px 8px;
    /deep/.ant-pagination {
      float: right;
      margin-top: 11px;
      margin-right: 66px;
    }
    /deep/.ant-pagination-item-active {
      border: 1px solid #0099ff !important;
      a {
        color: #0099ff !important;
      }
    }
    /deep/.ant-pagination-item {
      border-radius: 8px;
      border: 0px;
      font-size: 14px;
      a {
        color: #000000e0;
      }
    }
    /deep/.ant-pagination-item:hover {
      a {
        color: #0099ff !important;
      }
    }
    /deep/.ant-pagination-item-link {
      border: 0px;
    }
    /deep/.ant-select-selection-selected-value {
      font-size: 14px;
      color: #000000e0;
    }
    /deep/.ant-select-dropdown-menu-item {
      font-size: 14px;
      color: #000000e0;
    }
    /deep/.ant-select-selection {
      width: 94px;
      border-radius: 8px;
    }
    span {
      float: right;
      font-size: 14px;
      color: #000000e0;
      font-family: "AlibabaPuHuiTi_2_55_Regular";
      margin-right: 16px;
    }
  }
  margin-top: 12px;
  /deep/.el-table th.el-table__cell {
    background: #fff;
    border-radius: 0px 0px 0px 0px;
    height: 36px;
    padding: 0px;
  }
  /deep/.el-table th.el-table__cell > .cell {
    font-size: 12px;

    color: #666666;
    //padding-left: 20px;
    font-weight: 400px;
  }
  /deep/.el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #e8e8e8;
  }
  /deep/.el-table--enable-row-transition .el-table__body td.el-table__cell {
    height: 44px;
  }
  /deep/.el-table .cell {
    //padding-left: 20px;
    font-size: 12px;
    font-family: "AlibabaPuHuiTi_2_55_Regular";
    color: #333333;
    padding-right: 0px;
  }
}
/deep/.el-header {
  height: 60px;
  background-color: #fff;
  line-height: 60px;
  box-shadow: inset 0px -1px 0px 0px #e8e8e8;
  ul {
    display: inline-block;
  }
  ul:nth-child(1) {
    font-size: 18px;
    font-family: "AlibabaPuHuiTi_2_85_Bold";
    color: #333333;
    margin-left: -40px;
  }
}
/deep/.el-aside {
  width: 136px;
  margin: 12px;
  margin-right: 0px;
  background-color: inherit;
  box-shadow: 0px 0px 0px 0px inherit;
  border-radius: 8px;
}

.el-card__body,
.el-main {
  padding: 0px;
}

.main-aside {
  padding: 16px 14px;
  ul:first-child {
    margin-bottom: 8px;
  }
  .aside-dayorlive {
    height: 32px;
    line-height: 32px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-family: "Alibaba_PuHuiTi_Regular";
    color: #a2a09e;
    padding-left: 8px;
  }
  .dayactive {
    background: #e6f2ff !important;
    font-size: 12px;
    font-weight: 400;
    font-family: "Alibaba_PuHuiTi_Medium" !important;
    color: #0099ff !important;
  }
  .dayready {
    background: #e6f2ff;
    font-size: 12px;
    font-family: "Alibaba_PuHuiTi_Regular";
    color: #a2a09e;
  }
  .svg_icon {
    font-size: 16px;
    vertical-align: -0.2em;
    margin-right: 8px;
  }
}

.svg0 {
  color: #426cff;
}
</style>
